// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import './assets/iconfont/iconfont.css'
import moment from 'moment'
// import axios from 'axios'
// Vue.prototype.$axios = axios
// //Vue.prototype.$baseUrl = process.env.API_ROOT;
// axios.defaults.baseURL=process.env.BASE_API

Vue.use(Vant);

Vue.config.productionTip = false
Vue.prototype.$moment = moment;//赋值使用
moment.locale('zh-cn');//需要汉化
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js